<template>
    <div class="main-citizen">
        <h3 class="main-sub-tit">실시간 도시현황</h3>
        <a :href="$cp + 'realtime'" class="btn-more">더보기</a>
        <div class="main-citizen-left">
            <!-- 재난 안전 -->
            <div class="main-citizen-box01">
                <p class="tit">{{ safetyCount }}</p>
                <p class="txt">재난안전</p>
            </div>
            <!-- 교통 현황 -->
            <div class="main-citizen-box02">
                <p class="tit">{{ accidentCount }}</p>
                <p class="txt">교통현황</p>
            </div>
            <!-- 날씨 정보 -->
            <div class="main-citizen-box03">
                <p class="tit">날씨정보</p>
                <p :class="['ico', weatherClassNm]">{{ airSpace.forecastText }}</p>
                <p class="count">
                    <span class="now">{{ airSpace.t1hValue }}<b>℃</b></span>
                </p>
            </div>

            <transition-group appear mode="in-out" tag="div" class="main-citizen-box04">
                <div class="inbox"
                    v-for="(price, index) in priceList"
                    :key="price.dataTitle + ':' + price.dataUnit"
                    v-if="viewPriceIndex === (index + 1)">
                    <p class="tit" id="price_tit">
                        물가정보<span>({{ priceInfo.basdtVal | ymd }} 기준)</span>
                        <span style="cursor: pointer;"
                            :class="typeof priceRollingInterval === 'undefined' ? 'play' : 'stop'"
                            @click.prevent="togglePriceRolling"></span>
                    </p>
                    <p class="count">{{price.dataAvg | currency }}</p>
                    <p class="txt">
                        <span>{{ price.dataTitle }}({{ price.dataUnit }})</span>&nbsp;&nbsp;
                        <span :class="{'up': price.diff > 0, 'down': price.diff < 0}">{{ Math.abs(Math.round(price.diff)) }}원</span>
                    </p>
                </div>
            </transition-group>
        </div>
        <div class="main-citizen-right">
            <!-- 대기 정보 -->
            <div class="weather-box main">
                <strong>{{ airHjdAvg['pm10'] }}</strong> ㎍/㎥
                <p>미세먼지</p>
                <span :class="pm10LevelGrade[0]">{{ pm10LevelGrade[1] }}</span>
            </div>
            <div class="weather-box main">
                <strong>{{ airHjdAvg['pm25'] }}</strong> ㎍/㎥
                <p>초미세먼지</p>
                <span :class="pm25LevelGrade[0]">{{ pm25LevelGrade[1] }}</span>
            </div>
            <!-- 재정 현황 -->
            <div class="main-citizen-box04 finance">
                <p class="tit">재정현황<span>{{ (revenueList[0] ? revenueList[0].basdtVal : '') | ymd }} 기준</span></p>
                <div class="fi01">
                    <p class="count">{{totalCommonExpenditure | currency}}</p>
                    <p class="txt">
                        <span>총 세출액</span>
                    </p>
                </div>
                <div class="fi02">
                    <p class="count">{{totalCollcet | currency}}</p>
                    <p class="txt">
                        <span>총 세입액</span>
                    </p>
                </div>
            </div>
            <!-- 인구 정보 -->
            <transition-group appear mode="in-out" tag="div" class="main-citizen-box04">
                <div class="inbox" v-for="(population, index) in populationList" :key="population.code">
                     <p class="tit">
                         <span class="p_info" style="color: #FFF; font-size: 14px;">인구정보</span>
                         <span class="p_info">({{ populationBaseDay | formatDate('yyyy년 MM월 dd일') }} 기준)</span>
                         <span style="cursor: pointer;"
                               :class="typeof popInterval === 'undefined' ? 'play' : 'stop'"
                               @click.prevent="togglePopRolling"></span>
                     </p>
                     <div style="width: 50%;float: left;">
                        <p class="count" >{{ populationList[0].popCnt | currency }}</p>
                        <p class="txt" >
                            <span>{{ populationList[0].name }}</span>
                        </p>
                        <!-- <p class="count" v-show="viewPopIndex === 2">{{ populationList[0].popCnt | currency }}</p>
                        <p class="txt" v-show="viewPopIndex === 2">
                            <span>{{ populationList[0].name }}</span>
                        </p>
                        <p class="count" v-show="viewPopIndex === 3">{{ populationList[0].popCnt | currency }}</p>
                        <p class="txt" v-show="viewPopIndex === 3">
                            <span>{{ populationList[0].name }}</span>
                        </p> -->
                    </div>
                    <div style="width: 50%; float: right;" v-if="index >= 2">
                        <p class="count" v-show="viewPopIndex === 1">{{ populationList[2].popCnt | currency }}</p>
                        <p class="txt" v-show="viewPopIndex === 1">
                            <span>{{ populationList[2].name }}</span>
                        </p>
                        <p class="count" v-show="viewPopIndex === 2">{{ populationList[3].popCnt | currency }}</p>
                        <p class="txt" v-show="viewPopIndex === 2">
                            <span>{{ populationList[3].name }}</span>
                        </p>
                        <p class="count" v-show="viewPopIndex === 3">{{ populationList[4].popCnt | currency }}</p>
                        <p class="txt" v-show="viewPopIndex === 3">
                            <span>{{ populationList[4].name }}</span>
                        </p>
                        <p class="count" v-show="viewPopIndex === 4">{{ populationList[1].popCnt | currency }}</p>
                        <p class="txt" v-show="viewPopIndex === 4">
                            <span>{{ populationList[1].name }}</span>
                        </p>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { $WC } from "@/conf/common.const.js";
import commonConstMixin from "@/store/common.const.mixin.js";
import airLevel from '@/lib/air.level.js';
import financeMixin from "@/store/finance.mixin.js"

export default {
    name: 'Realtime',
    data() {
        return {
            viewPopIndex: 1,
            viewPriceIndex: 1,
            popInterval: undefined,
            priceRollingInterval: undefined,
        };
    },
    computed: {
        ...mapGetters({
            safetyTypeMap: 'getSafetyTypeMap',
            accidentMap: 'getAccidentCategoryMap',
            airHjdAvg: 'getAirHjdAvg',
            airSpace: 'getAirSpace',
            //waterQualityMap: 'getWaterQualityMap',
            priceInfo: 'getPriceInfo',
            hjdPopulationList: 'getHjdPopulationList',
            midTabs: 'getMidTabs',
        }),
        safetyCount() {
            let safetyCnt = 0;
            if(typeof this.safetyTypeMap['0'] !== $WC.UNDEF) {
                safetyCnt += this.safetyTypeMap['0'].length;
            }
            if(typeof this.safetyTypeMap['1'] !== $WC.UNDEF) {
                safetyCnt += this.safetyTypeMap['1'].length;
            }

            return safetyCnt;
        },
        accidentCount() {
            let accidentCnt = 0;
            for (const accidentList of Object.values(this.accidentMap)) {
                accidentCnt += accidentList.length;
            }
            return accidentCnt;
        },
        pm10LevelGrade() {
            return airLevel.pm10Level(this.airHjdAvg['pm10']);
        },
        pm25LevelGrade() {
            return airLevel.pm25Level(this.airHjdAvg['pm25']);
        },
        weatherClassNm() {
            if(this.airSpace.forecastDomain && this.airSpace.forecastCode) {
                return this.airSpace.forecastDomain + '_' + this.airSpace.forecastCode;
            } else {
                return "space_none";
            }
        },
        /*
        waterStateName() {
            if(typeof this.badWaterQuality === $WC.UNDEF) {
                return '정상';
            } else if(this.badWaterQuality > 0) {
                return this.badWaterQuality.facNm + ' 수질이상';
            } else {
                return this.badWaterQuality.facNm + ' 점검중';
            }
        },
        waterStateClass() {
            if(typeof this.badWaterQuality === $WC.UNDEF) {
                return '';
            } else if(this.badWaterQuality > 0) {
                return 'red';
            } else {
                return 'gray';
            }
        },
        */
        populationBaseDay() {
            if(this.hjdPopulationList[0]) {
                return this.hjdPopulationList[0].basdtVal;
            }
        },
        populationList() {
            let populationList = [
                {name: '총 인구', code: 'totalPop', index: 1, popCnt: 0},
                {name: '총 세대수', code: 'totalHouse', index: 2, popCnt: 0},
                {name: '0 ~ 14세', code: 'youngPop', index: 3, popCnt: 0},
                {name: '15 ~ 64세', code: 'adultPop', index: 4, popCnt: 0},
                {name: '65세 이상', code: 'oldPop', index: 5, popCnt: 0},
            ];

            let totalPopCols = this.midTabs.age.totalPop.popCols;
            let youngPopCols = this.midTabs.age.youngManPop.popCols;
            let adultPopCols = this.midTabs.age.adultManPop.popCols;
            let oldPopCols = this.midTabs.age.oldManPop.popCols;

            if(typeof this.hjdPopulationList !== $WC.UNDEF) {
                this.hjdPopulationList.forEach(hjdPop => {
                    totalPopCols.forEach(col => {
                        populationList[0].popCnt += Number(hjdPop[col]);
                    });

                    populationList[1].popCnt += Number(hjdPop['val48']);

                    youngPopCols.forEach(col => {
                        populationList[2].popCnt += Number(hjdPop[col]);
                    });
                    adultPopCols.forEach(col => {
                        populationList[3].popCnt += Number(hjdPop[col]);
                    });
                    oldPopCols.forEach(col => {
                        populationList[4].popCnt += Number(hjdPop[col]);
                    });

                })
            }
            return populationList;
        },
        priceList() {
            if(this.priceInfo.list) {
                return this.priceInfo.list;
            } else {
                return [];
            }
        },
        // 세출총계 금액
        totalCommonExpenditure() {
            let totalCommonExpenditure = this.commonExpenditureList.reduce((accu, expenditure) => {
                return accu + Number(expenditure.val22);
            }, 0);

            totalCommonExpenditure = Math.floor(totalCommonExpenditure/1000000000) * 10;

            return totalCommonExpenditure;
        },
        // 징수총계 금액
        totalCollcet() {
            let totalCollcet = 0;

            this.revenueList.forEach(function(revenue) {
                totalCollcet += Number(revenue.val7);
            }.bind(this));

            totalCollcet = Math.floor(totalCollcet/1000000000) * 10;

            return totalCollcet;
        },
    },
    created() {
        // 물가 정보 롤링
        this.$eventBus.$on('MainApp::loaded-price-info-data', () => {
            this.togglePriceRolling();
        });

        // 인구 정보 롤링
        this.togglePopRolling();
    },
    methods: {
        togglePopRolling() {
            if(typeof this.popInterval === $WC.UNDEF) {
                this.popInterval = setInterval(() => {
                    if(this.viewPopIndex === 4) {
                        this.viewPopIndex = 1;
                    } else {
                        this.viewPopIndex += 1;
                    }
                }, $WC.TEN_SEC_INTERVAL);
            } else {
                clearInterval(this.popInterval);
                this.popInterval = undefined;
            }
        },
        togglePriceRolling() {
            if(typeof this.priceRollingInterval === $WC.UNDEF) {
                this.priceRollingInterval = setInterval(() => {
                    if(this.viewPriceIndex === this.priceList.length) {
                        this.viewPriceIndex = 1;
                    } else {
                        this.viewPriceIndex += 1;
                    }
                }, $WC.SEVEN_SEC_INTERVAL);
            } else {
                clearInterval(this.priceRollingInterval);
                this.priceRollingInterval = undefined;
            }
        },
    },
    mixins: [commonConstMixin, financeMixin],
}
</script>
